/* eslint-disable no-useless-escape, max-len, no-misleading-character-class */
import { h } from 'preact';
import ColorSelector from './color-selector';
import TextInput from './text-input';
import Placements from './placements';

const Names = ({
  configuration,
  customizerSwatchesData,
  state,
  activeTab,
  dispatch,
}) => {
  const { color, font, text } = activeTab;
  if (typeof configuration === 'string') {
    // eslint-disable-next-line no-param-reassign
    configuration = JSON.parse(configuration);
  }
  const currentNameConfig = configuration.find(
    (curr) => curr.style.label === font,
  );
  const swatchesBlocks = customizerSwatchesData?.data?.blocks;
  const sectionDataColors = swatchesBlocks.filter(
    (block) => block.type === 'swatch-color' && block.color !== '',
  );
  const colorsToRender = sectionDataColors.filter((block) =>
    currentNameConfig.colors.includes(block.title),
  );

  const defaultPlacement = {
    label: state.metafieldData?.placement || 'Standard',
    horizontal: currentNameConfig.style.horizontal,
    vertical: currentNameConfig.style.vertical,
  };

  const { placements = [defaultPlacement] } = currentNameConfig;

  const handleColorClick = ({ title, hex }) => {
    dispatch({
      type: 'change_name',
      payload: {
        ...state[state.activeTab],
        color: title,
        colorHex: hex,
      },
    });
  };
  const handleInputChange = ({ value }) => {
    const specialCharactersFonts = [
      'Roman',
      'Arial',
      'Classic Script',
      'Handwritten',
      'Rockford',
    ];

    const payloadText = specialCharactersFonts.includes(font)
      ? value
      : value.replace(/[^a-zA-Z]+/g, '');
    dispatch({
      type: 'change_name',
      payload: {
        ...state[state.activeTab],
        text: payloadText,
      },
    });
  };

  const handlePlacementChange = (placement) => {
    dispatch({
      type: 'change_name',
      payload: {
        ...state[state.activeTab],
        placement,
      },
    });
  };

  const handleNameClick = ({ style }) => {
    const clickedNameConfig = configuration.find(
      (curr) => curr.style.label === style.label,
    );

    const isDefaultPlacement = (placement) =>
      placement.label === defaultPlacement.label &&
      placement.horizontal === defaultPlacement.horizontal &&
      placement.vertical === defaultPlacement.vertical &&
      placement.imageIndex === defaultPlacement.imageIndex;

    const currentState = state[state.activeTab];

    const hasMatchingPlacement =
      currentState.placement &&
      clickedNameConfig.placements?.some(
        (placement) =>
          placement.horizontal === currentState.placement.horizontal &&
          placement.vertical === currentState.placement.vertical &&
          placement.imageIndex === currentState.placement.imageIndex,
      );

    let placement;
    if (isDefaultPlacement(currentState) || !hasMatchingPlacement) {
      placement = clickedNameConfig.placements?.[0] || {
        ...defaultPlacement,
        horizontal: clickedNameConfig.style.horizontal,
        vertical: clickedNameConfig.style.vertical,
        imageIndex: clickedNameConfig.style.imageIndex,
      };
    } else {
      placement = currentState.placement;
    }

    let activeColor = currentState.color;
    if (!clickedNameConfig.colors.includes(activeColor)) {
      const firstAvailableColor = sectionDataColors.find((block) =>
        clickedNameConfig.colors.includes(block.title),
      );
      activeColor = firstAvailableColor ? firstAvailableColor.title : '';
    }

    dispatch({
      type: 'change_name',
      payload: {
        ...currentState,
        font: style.label,
        placement,
        text: clickedNameConfig.text.initialValue,
        textMaxLength: clickedNameConfig.text.maxLength || 3,
        color: activeColor,
      },
    });
  };

  const names = configuration.map((curr) => {
    const fontName = curr.style.label;
    return (
      <div
        // eslint-disable-next-line max-len
        className={`border border-1 hover:border-gray-900 text-center h-10 transition-all cursor-pointer text-xs flex items-center justify-center ${
          font === fontName ? 'border-gray-900' : 'border-gray-400'
        }`}
        style={{
          fontFamily: fontName,
          fontSize: fontName === 'Handwritten' ? 5 : 12,
        }}
        key={`${fontName}`}
        onClick={() => handleNameClick(curr)}
      >
        {fontName}
      </div>
    );
  });

  return (
    <div className="border border-1 border-x-0 border-t-0 border-gray-300 pb-5 mb-5">
      <Placements
        placements={placements}
        currentPlacement={state[state.activeTab].placement}
        defaultPlacement={defaultPlacement}
        onChangeHandler={handlePlacementChange}
      />
      <div className="border border-1 border-x-0 border-t-0 border-gray-300 pb-5 mb-5">
        <div className="body-3 mb-2.5">
          Font: <span className="font-medium">{font}</span>
        </div>
        <div className="grid grid-cols-5 gap-2 mb-3.5">{names}</div>
      </div>
      <ColorSelector
        colorsToRender={colorsToRender}
        clickHandler={handleColorClick}
        currentColor={color}
        overlayImage={customizerSwatchesData.data.monograms.image}
      />
      <TextInput
        currentText={text}
        textMaxLength={currentNameConfig.text.maxLength}
        textMinLength={currentNameConfig.text.minLength}
        changeHandler={handleInputChange}
      />
    </div>
  );
};

export default Names;
